import sendRequest from "../fetch"
import api from '../url'
import Qs from 'qs'
import { cleanParams } from "@/utils";

const _base = "zxStudentCourseLearn/";

// 课程学习进度 - 课程学习进度列表查询-分页 以课程为维度
export const myCourseLearnPage = (params) => {
         let _params = cleanParams(params);
         return sendRequest(api.url + _base + "myCourseLearnPage", {
           data: _params,
           method: "GET",
         });
       };
       
// 课程学习进度 - 视频学习进度列表-以章为维度
export const myVideoLearnList = (params) => {
         let _params = cleanParams(params);
         return sendRequest(api.url + _base + "myVideoLearnList", {
           data: _params,
           method: "GET",
         });
       };
// 课程学习进度 - 视频学习详细记录-分页
export const myLearnRecordPage = (params) => {
         let _params = cleanParams(params);
         return sendRequest(api.url + _base + "myLearnRecordPage", {
           data: _params,
           method: "GET",
         });
       };
// 课程学习进度 - 获取所有学习记录的所有课程列表-分页
export const learnRecodeCourseList = (params) => {
         let _params = cleanParams(params);
         return sendRequest(api.url + _base + "courseList", {
           data: _params,
           method: "GET",
         });
       };
// 课程学习进度 - 根据课程获取所有学习记录-分页
export const myVideoLearnRecord = (params) => {
         let _params = cleanParams(params);
         return sendRequest(api.url + _base + "videoLearnRecord", {
           data: _params,
           method: "GET",
         });
       };
// 课程学习进度 - 记录学习过程 
export const myVideoLearnAdd = (params) => {
         let _params = cleanParams(params);
         return sendRequest(api.url + _base + "add", {
           data: _params,
           method: "POST",
         });
       };


// WEBPACK FOOTER //
// ./src/fetch/api/videoStudy.js